module.exports = __WEBPACK_EXTERNAL_MODULE_117__;


//////////////////
// WEBPACK FOOTER
// external "react-portal"
// module id = 117
// module chunks = 0